// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"05773874","84":"31d6cfe0","141":"05773874","631":"56616d6a"}[chunkId] + ".chunk.css";
};